import React from "react";
export default function NewWaveCampKohSamui2026() {
  return <section id="new-wave-camp-koh-samui-2026" className="dark bg-background text-foreground relative w-full h-[100svh] min-h-[600px] flex items-center justify-center overflow-hidden bg-cover bg-center">
      {}
      <style>{`
        @keyframes scrollLineDown {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        .animate-scroll-line {
          animation: scrollLineDown 2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
        }
        @keyframes floatBadge {
          0%, 100% { transform: translateY(0) rotate(12deg); }
          50% { transform: translateY(-15px) rotate(16deg); }
        }
        .animate-float-badge {
          animation: floatBadge 6s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 w-full h-full bg-cover bg-[center_top] sm:bg-[center_top] md:bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/big_buddha_sunset_drone.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-black/10 md:bg-black/40" aria-hidden="true" />

      {}
      <div className="absolute top-24 md:top-32 left-0 right-0 mx-auto w-fit z-30 animate-float-badge">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/image_aq93vs1c.jpg" alt="Cena" className="w-72 md:w-40 h-auto object-contain drop-shadow-2xl mx-auto" />
      </div>

      {}
      <div className="relative z-20 flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4">
        <div className="text-center mb-12 max-w-3xl">
          <div className="text-secondary font-bold tracking-[0.3em] uppercase text-xs md:text-sm mb-3">
            TRENING & PRZYGODA
          </div>
          <div className="text-white text-4xl md:text-6xl font-serif italic mb-6">
            w Tajlandii
          </div>
          <p className="text-white/80 text-sm md:text-lg leading-relaxed max-w-2xl mx-auto">Dołącz do elitarnego obozu sportowego na Koh Samui. 12 dni intensywnego treningu Muay Thai i kickboxingu pod czujnym okiem Dawida Kasperskiego. Połącz trening z relaksem w tropikalnym raju.</p>
        </div>
        <div className="relative flex items-center justify-center w-full">
          {}
          <h1 className="text-[16vw] md:text-[10rem] lg:text-[13rem] font-black uppercase tracking-tighter text-transparent opacity-50 select-none text-center leading-[0.85]" style={{
          WebkitTextStroke: '2px rgba(255,255,255,0.4)'
        }}>
            DAWID<br />KASPERSKI
          </h1>

          {}
          <h2 className="absolute text-4xl md:text-7xl lg:text-8xl font-bold text-white uppercase tracking-widest text-center w-full drop-shadow-[0_10px_30px_rgba(0,0,0,0.9)]">
            NEW WAVE<br />
            <span className="text-primary">CAMP</span>
          </h2>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4 z-20">
        <span className="text-xs md:text-sm uppercase tracking-[0.3em] text-white/70 font-medium">
          Odkryj więcej
        </span>
        <div className="w-[2px] h-16 md:h-24 bg-white/10 relative overflow-hidden rounded-full">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-primary rounded-full animate-scroll-line" />
        </div>
      </div>
    </section>;
}